import { render } from "./NewsDetailPage.vue?vue&type=template&id=4dbc9d4a&scoped=true"
import script from "./NewsDetailPage.vue?vue&type=script&lang=js"
export * from "./NewsDetailPage.vue?vue&type=script&lang=js"

import "./NewsDetailPage.vue?vue&type=style&index=0&id=4dbc9d4a&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4dbc9d4a"]])

export default __exports__